import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import Grid from "@mui/material/Grid";
import { NodoDto } from "@/api";
import DispositivoCard from "@/components/DispositivoCard";
import { useMemo, useState } from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function MacchinariSensoriTable({
  nodo,
  title,
}: {
  title?: string;
  nodo: NodoDto;
}) {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t("macchinariSensoriTable.titolo");
  const [search, setSearch] = useState("");

  const nodiFigli = nodo.nodiFigli || [];
  const [allDispositivi, dispositivi] = useMemo(() => {
    const allDispositivi = nodiFigli.filter(
      (n) =>
        n.tipo === "Dispositivo_Sensore" || n.tipo === "Dispositivo_Macchinario"
    );

    const cleanSearch = search.trim().toLowerCase();
    const dispositivi = allDispositivi.filter((n) => {
      return (
        (n.dispositivoMatricola ?? "").toLowerCase().indexOf(cleanSearch) >= 0
      );
    });

    return [allDispositivi, dispositivi] as const;
  }, [nodiFigli, search]);

  return (
    <Box flex={1}>
      <Box display="flex" flexDirection="column" height="100%" gap={1}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          gap={1}
        >
          <Typography variant="h5" color="text" fontWeight="medium">
            {resolvedTitle}
          </Typography>
          <Box flex={1} />
          <TextField
            placeholder={t("macchinariSensoriTable.filtri.matricola")}
            value={search}
            onChange={(e) => {
              setSearch(e.target.value || "");
            }}
            size="small"
          />
        </Box>
      </Box>

      <Box
        mt={2}
        mb={0}
        display="flex"
        flexDirection="row"
        flexWrap="wrap"
        gap={2}
      >
        {dispositivi.map((dispositivo) => {
          return (
            <DispositivoCard
              dispositivo={dispositivo}
              proprietaMisurate={dispositivo.dispositivoProprietaMisurate || []}
              showPosizione={false}
            />
          );
        })}
      </Box>

      {dispositivi.length === 0 ? (
        allDispositivi.length === 0 ? (
          <Typography mt={2} variant="body2">
            {t("macchinariSensoriTable.noDispositivi")}
          </Typography>
        ) : (
          <Typography mt={2} variant="body2">
            {t("macchinariSensoriTable.noDispositiviPerMatricola", {
              matricola: search,
            })}
          </Typography>
        )
      ) : null}
    </Box>
  );
}
